import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  error: '',
  pointsResult: null,
  cashResult: null,
  encashmentResult: null,
  redemptionResult: null,
}

const rewardCalculatorSlice = createSlice({
  name: 'rewardCalculator',
  initialState,
  reducers: {
    tryCalculatePoints: () => {},
    tryCalculateCash: () => {},
    tryCalculateEncashment: () => {},
    tryValidateRedemption: () => {},
    setPointsResult: (state, action) => {
      return { ...state, pointsResult: action.payload, loading: false, error: '' }
    },
    setCashResult: (state, action) => {
      return { ...state, cashResult: action.payload, loading: false, error: '' }
    },
    setEncashmentResult: (state, action) => {
      return { ...state, encashmentResult: action.payload, loading: false, error: '' }
    },
    setRedemptionResult: (state, action) => {
      return { ...state, redemptionResult: action.payload, loading: false, error: '' }
    },
    setLoading: (state, action) => {
      return { ...state, loading: action.payload }
    },
    setError: (state, action) => {
      return { ...state, error: action.payload, loading: false }
    },
    resetCalculatorState: () => initialState,
  },
})

export const {
  tryCalculatePoints,
  tryCalculateCash,
  tryCalculateEncashment,
  tryValidateRedemption,
  setPointsResult,
  setCashResult,
  setEncashmentResult,
  setRedemptionResult,
  setLoading,
  setError,
  resetCalculatorState,
} = rewardCalculatorSlice.actions

export default rewardCalculatorSlice.reducer
